<template>
  <div v-if="hasScheduledKeywordIndexing" class="opportunity-documents-queue-state__container">
    <div class="opportunity-documents-queue-state__steps-container">
      <div v-for="(step, index) in steps" :key="index" class="opportunity-documents-queue-state__step">
        <span class="icon">
          <!-- completed -->
          <template v-if="index < currentStepIndex">
            <BaseIcon name="check-circle" class="opportunity-documents-queue-state__step-completed-icon" />
          </template>
          <!-- in progress -->
          <template v-else-if="index === currentStepIndex">
            <BaseCircularLoadingBar :size="16" :width="2" />
          </template>
          <template v-else>
            <span class="opportunity-documents-queue-state__step-not-started-icon"></span>
          </template>
        </span>
        <span>{{ step.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseCircularLoadingBar from '@/components/base/BaseCircularLoadingBar.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'OpportunityDocumentsQueueState',
  components: { BaseIcon, BaseCircularLoadingBar },
  data() {
    return {
      currentStepIndex: -1,
    };
  },
  computed: {
    ...mapGetters('opportunityDocumentsQueue', ['queueMessages', 'hasScheduledKeywordIndexing']),
    currentEvent() {
      return this.queueMessages.length > 0 ? this.queueMessages[0] : null;
    },
    isRunning() {
      return this.currentEvent ? this.currentEvent.queueOrder === 0 : false;
    },
    steps() {
      return [
        {
          text:
            this.currentStepIndex === 0 && this.currentEvent
              ? this.$tc('page.opportunity-details.documents-queue-state.order', this.currentEvent.queueOrder - 1, {
                  order: this.currentEvent.queueOrder,
                  documentsInLine: this.currentEvent.queueOrder - 1,
                })
              : this.$t(`page.analysis.keyword-navigator.scheduled`),
        },
        {
          text: this.$tc(`page.analysis.keyword-navigator.loading`, this.currentStepIndex + 1),
          queueMessageType: ['documents_pipeline_run', 'documents_deleted'],
        },
      ];
    },
  },
  watch: {
    currentEvent: {
      immediate: true,
      handler() {
        if (!this.currentEvent) {
          this.currentStepIndex = -1;
          return;
        }

        // If the event is not yet started, return the scheduled step index
        if (!this.isRunning) {
          this.currentStepIndex = 0;
          return;
        }

        const messageType = this.currentEvent.body.messageType;
        this.currentStepIndex = this.steps.findIndex(
          (step) => step.queueMessageType && step.queueMessageType.includes(messageType),
        );
      },
    },
  },
};
</script>

<style scoped lang="scss">
.opportunity-documents-queue-state {
  &__container {
    color: $color-neutral;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__steps {
    &-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      gap: 16px;
    }

    &.vertical {
      display: flex;
      justify-self: center;
      flex-direction: column;
    }
  }

  &__step {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;

    &-not-started-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid $color-neutral;
    }

    &-completed-icon {
      width: 16px;
      color: $color-green;
    }
  }

  &__schedule {
    display: flex;
    flex-direction: column;
  }
}
</style>
